// extracted by mini-css-extract-plugin
export default {"channel":"channel_channel__6rQo0","channel_heading":"channel_channel_heading__M04bb"};